<template>
<header>
    <img src="../assets/icons/logo.svg">
    <div class="profileBlock">
    <img :src='user.photo_url'/>
    <p>{{user.username}}</p>
    </div>
</header>
<div class="addWhore">
    <p class='addWhoreHead'>Добавление новой анкеты</p>
    <div class="addWhoreBlock">
    <p>Полное имя</p>
    <input type="text" id='fullName' v-model="fullName" placeholder='Введите имя и фамилию'/>
    <p>Национальность</p>
    <multiselect v-model="nationality" :options="nationalityOptions" :searchable="false" :close-on-select="false" :show-labels="false" :preselect-first="true" track-by="name" label="name" :allowEmpty="false"
                placeholder="Выберите национальность"></multiselect>
    <p>Внешность</p>
    <multiselect v-model="appearance" :options="appearanceOptions" :searchable="false" :close-on-select="false" :show-labels="false" :preselect-first="true" track-by="name" label="name" :allowEmpty="false"
                placeholder="Выберите внешность"></multiselect>
    <p>Возраст</p>
    <input type="number" id='age' v-model="age" min="18" max="70" placeholder='Введите возраст' @change="age < 18 ? age = 18 : (age > 70 ? age = 70 : age)"/>
    <p>Размер груди</p>
    <input type="number" id='boobsSize' v-model="boobsSize" min="1" max="7" placeholder='Введите размер груди' @change="boobsSize < 1 ? boobsSize = 1 : (boobsSize > 7 ? boobsSize = 7 : boobsSize)"/>
    <p>Рост</p>
    <input type="number" id='height' v-model="height" min="120" max="220" placeholder='Введите рост модели' @change="height < 120 ? height = 120 : (height > 220 ? height = 220 : height)"/>
    <p>Вес</p>
    <input type="number" id='weight' v-model="weight" min="35" max="120" placeholder='Введите вес модели' @change="weight < 35 ? weight = 35 : (weight > 120 ? weight = 120 : weight)"/>
    <p>Место</p>
    <multiselect v-model="place" :options="placeOptions" :searchable="false" :close-on-select="false" :show-labels="false" :preselect-first="true" track-by="name" label="name" :allowEmpty="false"
                placeholder="Выберите место встречи"></multiselect>
    <p>Возрастное ограничение (от X лет)</p>
    <input type="number" id='ageRestriction' v-model="ageRestriction" min="18" placeholder='Введите возрастное ограничение' @change="ageRestriction < 18 ? ageRestriction = 18 : ageRestriction"/>
    <p>Город</p>
    <multiselect v-model="cityName" :options="cities" :searchable="false" :close-on-select="false" :show-labels="false" :preselect-first="true" :allowEmpty="false"
                placeholder="Выберите город"></multiselect>
    <p>Предпочтения (минимум 2)</p>
    <multiselect v-model="preference" :options="preferenceOptions" :multiple="true" :searchable="false" :close-on-select="false" track-by="name" label="name" :show-labels="false"
                placeholder="Выберите предпочтения"></multiselect>
    <p>Описание</p>
    <input type="text" id='description' v-model="description" placeholder='Введите описание модели'/>
    <p>Проститутка</p>
    <div class="checkbox-container">
        <label>
        <input type="checkbox" id='slut' v-model="slut"/>
        <span class="checkbox-label">{{ slut ? '✔' : 'X' }}</span>
        </label>
    </div>
    <p>Индивидуалка</p>
    <div class="checkbox-container">
        <label>
        <input type="checkbox" id='individual' v-model="individual"/>
        <span class="checkbox-label">{{ individual ? '✔' : 'X' }}</span>
        </label>
    </div>
    <p>Эскортница</p>
    <div class="checkbox-container">
        <label>
        <input type="checkbox" id='escort' v-model="escort"/>
        <span class="checkbox-label">{{ escort ? '✔' : 'X' }}</span>
        </label>
    </div>
    <p>Премиум</p>
    <div class="checkbox-container">
        <label>
        <input type="checkbox" id='premium' v-model="premium"/>
        <span class="checkbox-label">{{ premium ? '✔' : 'X' }}</span>
        </label>
    </div>
    <p>Элитная</p>
    <div class="checkbox-container">
        <label>
        <input type="checkbox" id='elite' v-model="elite"/>
        <span class="checkbox-label">{{ elite ? '✔' : 'X' }}</span>
        </label>
    </div>
    <p>Массажистка</p>
    <div class="checkbox-container">
        <label>
        <input type="checkbox" id='massage' v-model="massage"/>
        <span class="checkbox-label">{{ massage ? '✔' : 'X' }}</span>
        </label>
    </div>
    <p>Фото</p>
    <input type="file" placeholder='Фото' id='photos' multiple/>
    <p>Цена за час</p>
    <input type="number" placeholder='Введите цену за час в рублях' id='oneHourPrice' v-model="oneHourPrice"/>
    <p>Цена за ночь</p>
    <input type="number" placeholder='Введите цену за ночь в рублях' id='nightPrice' v-model="nightPrice"/>
    </div>
</div>
<MainButton text="Добавить" @click="addWhore" />
</template>

<script>
import { MainButton, useWebApp, useWebAppPopup } from 'vue-tg'
import Multiselect from 'vue-multiselect'
import { useToast } from 'vue-toastification'
import axios from 'axios'
export default {
data() {
    return {
    user: useWebApp().initDataUnsafe.user,
    fullName: "",
    nationality: "",
    nationalityOptions: [
        {name: 'Русская', value: 'RUSSIAN'},
        {name: 'Татарка', value: 'TATARIAN'},
        {name: 'Азербайджанка', value: 'AZERBAIJANIAN'},
        {name: 'Украинка', value: 'UKRAINIAN'},
        {name: 'Казашка', value: 'KAZAKHNIAN'},
    ],
    appearance: "",
    appearanceOptions: [
        {name: 'Славянская', value: 'SLAVENIAN'},
        {name: 'Азиатская', value: 'ASIAN'},
    ],
    age: "",
    boobsSize: "",
    height: "",
    weight: "",
    place: "",
    placeOptions: [
        {name: 'У тебя', value: 'YOU'},
        {name: 'У меня', value: 'ME'},
        {name: 'У тебя или у меня', value: 'YOUME'},
    ],
    ageRestriction: "",
    cityName: "",
    description: "",
    slut: false,
    individual: false,
    escort: false,
    premium: false,
    elite: false,
    massage: false,
    photos: [],
    oneHourPrice: "",
    nightPrice: "",
    preference: [],
    preferenceOptions: [
        "Секс",
        "Анальный секс",
        "Оральный секс",
    ],
    cities: []
    }
},
methods: {
    async addWhore() {
        const { showAlert } = useWebAppPopup()
        if (this.checkAllFields()) {
            let newPreferences = this.preference.map(item => item.value)
            this.photos = document.querySelector('#photos').files
            const formData = new FormData();
            formData.append('fullName', this.fullName);
            formData.append('nationality', this.nationality.value);
            formData.append('appearance', this.appearance.value);
            formData.append('age', this.age);
            formData.append('boobsSize', this.boobsSize);
            formData.append('height', this.height);
            formData.append('weight', this.weight);
            formData.append('place', this.place.value);
            formData.append('ageRestriction', this.ageRestriction);
            formData.append('cityName', this.cityName);
            for (let i = 0; i < newPreferences.length; i++) {
            formData.append(`preference`, newPreferences[i]);
            }
            formData.append('description', this.description);
            formData.append('slut', this.slut);
            formData.append('individual', this.individual);
            formData.append('escort', JSON.stringify(this.escort));
            formData.append('premium', this.premium);
            formData.append('elite', this.elite);
            formData.append('massage', this.massage);
            formData.append('oneHourPrice', this.oneHourPrice);
            formData.append('nightPrice', this.nightPrice);
            for (let i = 0; i < this.photos.length; i++) {
                formData.append(`photos`, this.photos[i]);
            }
            axios.post(`https://${process.env.VUE_APP_SERVERHOST}/api/girl`, formData, {
                headers: {
                    authorization: useWebApp().initData,
                }
            })
            .then(res => {
                console.log(res)
                showAlert("Модель успешно добавлена!")
                window.open(res.data.result.bot_url);
            })
            .catch(err => {
                console.log(err)
                this.toast.error(err.response.data.message)
            })
        }
    },
    getPreferences() {
    axios.get(`https://${process.env.VUE_APP_SERVERHOST}/api/public/preferences`)
            .then(res => {
                console.log(res)
        this.preferenceOptions = res.data.result.map(item => ({name: item.name, value: item._id}))
        console.log(this.preferenceOptions)
            })
            .catch(err => {
                console.log(err)
            })
    },
    getCities() {
    axios.get(`https://${process.env.VUE_APP_SERVERHOST}/api/public/cities`)
            .then(res => {
                console.log(res)
        this.cities = res.data.result.map(item => item.name)
            })
            .catch(err => {
                console.log(err)
            })
    },
    checkAllFields() {
        let newPreferences = this.preference.map(item => item.value)
        let fields = [this.fullName, this.age, this.boobsSize, this.height, 
        this.weight, this.ageRestriction, this.cityName, newPreferences, this.description, this.oneHourPrice, this.nightPrice]

        for (let i = 0; i < fields.length; i++) {
            // console.log(fields[i].length)
            if (fields[i].length == 0) {
                this.toast.error("Вы заполнили не все поля!")
                return false
            }
            if (newPreferences.length < 2){
                this.toast.error("Вы заполнили не все поля!")
                return false
            }
            if (this.oneHourPrice < 1500) {
                this.toast.error("Цена за 1 час не может быть меньше 1500!")
                return false
            }
            if (this.nightPrice < 1500) {
                this.toast.error("Цена за ночь не может быть меньше 1500!")
                return false
            }
        }
        return true
    }
},
mounted() {
    this.getPreferences()
    this.getCities()
    setTimeout(() => {
        let el = document.querySelector('.woot-widget-bubble')
        console.log(el)
        if (el) {
            el.remove()
            console.log('delete chat.')
        }
    }, 500)
    
},
setup() {
    const toast = useToast()
    return { toast }
},
components: {
    MainButton, Multiselect
}
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
#app {
background-color: white;
}
* {
box-sizing: border-box;
}
header {
display: flex;
justify-content: space-between;
align-items: center;
background-color: #F6FAFD;
padding-left:5%;
padding-right: 5%;
}
.profileBlock {
display: flex;
align-items: center;
gap:5px;
}
.profileBlock img {
width: 35px;
border-radius: 55px;
}
.profileBlock p {
font-weight: 600;
}
.addWhoreHead {
font-size: 4vw;
font-weight: 600;
}
.addWhore {
background-color: white;
padding:5%;
border-radius: 0 0 10px 10px;
}
.addWhoreBlock {
display: grid;
grid-template-columns: 1fr 2fr;
gap:10px;
width: 100%;
}
.addWhoreBlock p {
font-size: 14px;
}
input {
    outline: none;
    background-color: #FFFFFF;
    border-radius: 10px;
    border: 1px solid #D8DADC;
    padding: 15px;
font-size: 13px;
width: 100%;
}
textarea {
outline: none;
background-color: #FFFFFF;
border-radius: 10px;
border: 1px solid #D8DADC;
padding: 15px;
resize: none;
}
* {
font-family: 'Open Sans', sans-serif;
}
:deep(.multiselect) {
font-size: 13px;
}
:deep(.multiselect__single) {
font-size: 13px;
}
:deep(.multiselect__tags) {
border-radius: 10px;
}
.checkbox-container {
width: 100%;
}

label {
display: flex;
align-items: center;
width: 100%;
cursor: pointer;
}

input[type="checkbox"] {
display: none; /* Скрываем реальный чекбокс */
}

.checkbox-label {
display: block;
width: 100%;
height: 100%;
background-color: #FFFFFF;
border: 1px solid #D8DADC;
border-radius: 10px;
padding: 10px;
text-align: center;
transition: background-color 0.3s ease;
font-weight: 600;
user-select: none;
}

input[type="checkbox"]:checked + .checkbox-label {
background-color: #d0f0d0; /* Цвет при активации */
border-color: #7cbd7c;
}
:deep(.multiselect__tag) {
text-wrap: auto;
}
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');
</style>
